module.exports = __webpack_public_path__ + "img/SOSLogo.7b833979.png";